"use client";

import React from 'react';

export default function ManualInscripcionDiagram() {
    return (
        <div className="w-full p-8 md:p-12 bg-white dark:bg-zinc-900 leading-tight">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4 relative">
                {/* Step 1: Pre-registration */}
                <div className="flex-1 w-full max-w-sm flex flex-col items-center text-center group">
                    <div className="w-20 h-20 rounded-2xl bg-secondary/10 flex items-center justify-center mb-6 border-2 border-secondary/20 group-hover:bg-secondary/20 transition-colors duration-300">
                        <span className="material-icons text-4xl text-secondary">assignment</span>
                    </div>
                    <div className="space-y-2">
                        <div className="flex items-center justify-center gap-2 mb-1">
                            <span className="text-xs font-bold px-2 py-0.5 rounded bg-secondary text-white uppercase tracking-wider">Fase 1</span>
                        </div>
                        <h3 className="text-xl font-display uppercase text-black dark:text-white">Preinscripción</h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            Completa tus datos y obtén tu <span className="font-bold text-secondary">código de pago</span>.
                        </p>
                    </div>
                </div>

                {/* Connector - Desktop */}
                <div className="hidden md:flex flex-[0.5] items-center justify-center">
                    <div className="w-full h-px bg-gradient-to-r from-secondary/50 via-primary/50 to-primary/50 relative">
                        <span className="material-icons absolute -right-3 -top-3 text-xl text-primary font-bold">chevron_right</span>
                    </div>
                </div>

                {/* Connector - Mobile */}
                <div className="flex md:hidden items-center justify-center py-2">
                    <span className="material-icons text-3xl text-primary animate-bounce">expand_more</span>
                </div>

                {/* Step 2: Payment */}
                <div className="flex-1 w-full max-w-sm flex flex-col items-center text-center group">
                    <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mb-6 border-2 border-primary/20 group-hover:bg-primary/20 transition-colors duration-300">
                        <span className="material-icons text-4xl text-primary">credit_card</span>
                    </div>
                    <div className="space-y-2">
                        <div className="flex items-center justify-center gap-2 mb-1">
                            <span className="text-xs font-bold px-2 py-0.5 rounded bg-primary text-black uppercase tracking-wider">Fase 2</span>
                        </div>
                        <h3 className="text-xl font-display uppercase text-black dark:text-white">Inscripción y Pago</h3>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            Usa tu código para realizar el pago y <span className="font-bold text-primary">confirmar tu plaza</span>.
                        </p>
                    </div>
                </div>

                {/* Final State */}
                <div className="hidden lg:flex flex-[0.3] items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-green-500/10 flex items-center justify-center border-2 border-green-500/20">
                        <span className="material-icons text-2xl text-green-500 font-bold">check_circle</span>
                    </div>
                </div>
            </div>

            {/* Timeline info */}
            <div className="mt-12 pt-8 border-t border-gray-100 dark:border-zinc-800 grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="flex items-start gap-4">
                    <div className="w-2 h-2 rounded-full bg-secondary mt-1.5" />
                    <div>
                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Disponible desde</p>
                        <p className="text-sm font-medium text-black dark:text-white">20 Enero @ 10:00h</p>
                    </div>
                </div>
                <div className="flex items-start gap-4">
                    <div className="w-2 h-2 rounded-full bg-primary mt-1.5" />
                    <div>
                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Apertura pagos</p>
                        <p className="text-sm font-medium text-black dark:text-white">06 Febrero @ 21:00h</p>
                    </div>
                </div>
                <div className="flex items-start gap-4">
                    <div className="w-2 h-2 rounded-full bg-[#FF3131] mt-1.5" />
                    <div>
                        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Cierre inscripciones</p>
                        <p className="text-sm font-medium text-black dark:text-white">15 Octubre @ 21:00h</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
